// extracted by mini-css-extract-plugin
export default {"main":"AdminInvoicingPage_main__ENWPr","titleBar":"AdminInvoicingPage_titleBar__bi+6N"};